import { defineComponent as _defineComponent } from 'vue'
import BKSvgIcon from '@/components/AppShared/BKSvgIcon.vue'
import { UserNotification } from '@/enitites/user'
import { useRouter } from 'vue-router/composables'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationEventFeedbackAttendee',
  props: {
    notification: null,
    readUserNotification: null
  },
  setup(__props: any) {

const props = __props as {
  notification: UserNotification
  readUserNotification: (notification: UserNotification) => void
};



const router = useRouter()

const handleProvideFeedback = () => {
  if (router.currentRoute?.name !== `Event` || router.currentRoute.query.tab !== 'feedback') {
    router.push({
      name: 'Event',
      params: { id: `${props.notification.eventId}` },
      query: { tab: 'feedback' },
    })
  }
  props.readUserNotification(props.notification)
}

return { __sfc: true,props, router, handleProvideFeedback, BKSvgIcon }
}

})